import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { supplierRecordQuery } from "@/app/Suppliers/GraphQL/supplierRecordQuery";

export function useSupplierRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/suppliers/_supplierRecordLayout/$id",
  });
  const { data } = useSuspenseGqlQuery(supplierRecordQuery, {
    id: match.params.id,
  });

  return data.supplier;
}

export function useSupplier(supplierId: string) {
  const { data } = useSuspenseGqlQuery(supplierRecordQuery, {
    id: supplierId,
  });

  return data.supplier;
}
